module.exports = __webpack_public_path__ + "static/media/themainmain.798646be.jpeg";